import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot } from 'lexical';
import { useEffect } from 'react';

export function DefaultCodeLanguagePlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      editor.registerUpdateListener(({ editorState }) => {
        editorState.read(() => {
          const root = $getRoot();
          const stack: any[] = [root];
          while (stack.length) {
            const node = stack.pop();
            const children = node.getChildren?.() ?? [];
            for (const child of children) stack.push(child);
            if (node.getType?.() === 'code') {
              const language = node.getLanguage?.();
              if (!language) node.setLanguage?.('tsx');
            }
          }
        });
      }),
    [editor],
  );

  return null;
}
